import React from 'react'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'

const BreadcrumbContainer = styled.nav`
  background: #f8fafc;
  border-bottom: 1px solid #e5e7eb;
  padding: 0.75rem 1rem;
  
  @media (min-width: 640px) {
    padding: 0.75rem 1.5rem;
  }
`

const BreadcrumbList = styled.ol`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  list-style: none;
  padding: 0;
  font-size: 0.875rem;
  color: #6b7280;
`

const BreadcrumbItem = styled.li`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  &:not(:last-child)::after {
    content: '/';
    color: #9ca3af;
  }
`

const BreadcrumbLink = styled.a`
  color: inherit;
  text-decoration: none;
  transition: color 0.2s;

  &:hover {
    color: #374151;
  }

  &.current {
    color: #111827;
    font-weight: 500;
  }
`

const HomeIcon = styled.span`
  font-size: 1rem;
`

function Breadcrumb() {
  const location = useLocation()
  
  const pathMap = {
    '/': 'Dashboard',
    '/emails': 'Email Management',
    '/cohorts': 'Cohort Management'
  }

  const getBreadcrumbItems = () => {
    const items = []
    
    // Always start with Home
    items.push({
      label: 'Home',
      path: '/',
      isCurrent: location.pathname === '/'
    })

    // Add current section if not home
    if (location.pathname !== '/') {
      const currentSection = pathMap[location.pathname]
      if (currentSection) {
        items.push({
          label: currentSection,
          path: location.pathname,
          isCurrent: true
        })
      }
    }

    return items
  }

  const breadcrumbItems = getBreadcrumbItems()

  return (
    <BreadcrumbContainer aria-label="Breadcrumb">
      <BreadcrumbList>
        {breadcrumbItems.map((item, index) => (
          <BreadcrumbItem key={item.path}>
            {index === 0 ? (
              <BreadcrumbLink 
                href={item.path}
                className={item.isCurrent ? 'current' : ''}
                aria-current={item.isCurrent ? 'page' : undefined}
              >
                <HomeIcon>🏠</HomeIcon>
              </BreadcrumbLink>
            ) : (
              <BreadcrumbLink 
                href={item.path}
                className={item.isCurrent ? 'current' : ''}
                aria-current={item.isCurrent ? 'page' : undefined}
              >
                {item.label}
              </BreadcrumbLink>
            )}
          </BreadcrumbItem>
        ))}
      </BreadcrumbList>
    </BreadcrumbContainer>
  )
}

export default Breadcrumb
